<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gIzt7B/tc-custom/9781632658807.jpg?1726871242574" alt="This image is the cover for the book Manager's Answer Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Manager's Answer Book
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning Q&amp;A guide on management from the authors of <i>The Big Book of HR</i>.</b><br/><br/><i>2020 Winner, Next Generation Indie Book Award in the Career Category</i><br/><br/>Congratulations, you’re a manager! Now what?<br/><br/>Of course, you have expertise in the field you’re managing—but there’s so much more to know, and your responsibilities can become overwhelming at times. A management career means continuous learning: encountering new situations, solving new problems, and gaining new skills on a constant basis. In question-and-answer format, this easy-to-use guide provides information on many aspects of managing, including:<br/><br/>• Getting started: moving from peer to manager, setting goals, managing projects, resources, and much more<br/><br/>• Developing your management skills: communicating, delegating, motivating, and facilitating<br/><br/>• Building and managing your team: hiring, firing, and everything in between<br/><br/>• Creating your personal brand: building credibility for yourself, your team, and your department<br/><br/>• Managing up, down, and around: working with people and functions in your organization<br/><br/>• Potential land mines: conflict, change, and risk<br/><br/>• Legal pitfalls: navigating the miasma of laws and regulations, and more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Mitchell, Cornelia Gamlem
      </h2>
      
      <p class="authorDescription body article">A writing partnership was born when the first edition of The Big Book of HR hit the market in 2012. Since that time, Barbara Mitchell and Cornelia Gamlem have gone on to write four more books, see them translated into other languages, and receive prestigious awards.  Barbara Mitchell is enthusiastic about helping organizations find, hire, engage and retain the best available talent. That's why she began consulting after working as an HR Executive in corporations. She's the founder and Managing Partner of The Mitchell Group, a management consulting practice that helps a wide variety of clients with people and talent management issues.   Cornelia Gamlem is passionate about helping organizations develop and maintain respectful workplaces. For that reason, she took her HR expertise, gained working for a Fortune 500 IT services company, and founded the Gems Group, a management consulting firm offering clients solutions to employee relations, workplace diversity and related HR and business issues.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Career Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ac4a72f2